interface ISVGRProps {
  title?: string;
  titleId?: string;
}

type IconProps = React.SVGProps<SVGSVGElement> & ISVGRProps;

export enum ICON {
  ADD_ROW_24 = "add-row-24",
  ARROW_RIGHT_16 = "arrow-right-16",
  ARROW_RIGHT_24 = "arrow-right-24",
  ARROW_RIGHT_INVERSE_24 = "arrow-right-inverse-24",
  ARROW_UP = "arrow-up",
  ARROW_UP_RIGHT_16 = "arrow-up-right-16",
  BOOK_20 = "book-20",
  CALL_CANCEL = "call-cancel",
  CHAT_BUBBLE_20 = "chat-bubble-20",
  CHAT_BUBBLE_POINTER = "chat_bubble_pointer",
  CHECK_16 = "check-16",
  CHECKBOX_24 = "checkbox-24",
  CHECKBOX_CHECKED_24 = "checkbox-checked-24",
  CHECKBOX_DOWN_24 = "chevron-down-24",
  CHEVRON_DOWN_16 = "chevron-down-16",
  CHEVRON_LEFT_16 = "chevron-left-16",
  CHEVRON_LEFT_20 = "chevron-left-20",
  CHEVRON_LEFT_24 = "chevron-left-24",
  CHEVRON_RIGHT_16 = "chevron-right-16",
  CHEVRON_RIGHT_24 = "chevron-right-24",
  CHEVRON_TOP_24 = "chevron-top-24",
  CLOSE_16 = "close-16",
  CLOSE_24 = "close-24",
  CONVAI_20 = "convai-20",
  COPY_16 = "copy-16",
  CROSS_24 = "cross-24",
  CUSTOM_PRESET_24 = "custom-preset-24",
  DE_FLAG_20 = "de-flag-20",
  DISCORD_24 = "discord-24",
  DOWNLOAD_20 = "download-20",
  DUBBING_20 = "dubbing-20",
  EDIT_MODE_24 = "edit-mode-24",
  ELEVEN_MUSIC_20 = "eleven-music-20",
  ES_FLAG_20 = "es-flag-20",
  FACEBOOK_24 = "facebook-24",
  GITHUB_24 = "github-24",
  GLOBE_20 = "globe-20",
  INFO_16 = "info-16",
  LINKEDIN_24 = "linkedin-24",
  MENU_24 = "menu-24",
  MIC = "mic",
  MIC_20 = "mic-20",
  MIC_OFF = "mic-off",
  MINUS_24 = "minus-24",
  MUTED = "muted",
  NEW_PRESET_24 = "new-preset-24",
  PAUSE_20 = "pause-20",
  PAUSE_24 = "pause-24",
  PL_FLAG_20 = "pl-flag-20",
  PLAY = "play",
  PLAY_20 = "play-20",
  PLAY_24 = "play-24",
  PLUS_24 = "plus-24",
  PROJECTS_20 = "projects-20",
  RADIO_24 = "radio-24",
  READER_20 = "reader-20",
  SAFETY_20 = "safety-20",
  SE_FLAG_20 = "se-flag-20",
  SHARE_16 = "share-16",
  SMILE_PLUS_20 = "smile-plus-20",
  SOUND_ON = "sound_on",
  SPINNER_20 = "spinner-24",
  STAR_20 = "star-20",
  STOP_20 = "stop-20",
  STS_20 = "sts-20",
  STT_20 = "stt-20",
  TICK_16 = "tick-16",
  TICK_24 = "tick-24",
  TOOL_CALL = "tool_call",
  TTS_20 = "tts-20",
  TTSFX_20 = "ttsfx-20",
  US_FLAG_20 = "us-flag-20",
  VIDEO_20 = "video-20",
  VOICE_CLONING_20 = "voice-cloning-20",
  VOICE_DESIGN_20 = "voice-design-20",
  VOICE_ISOLATOR_20 = "voice-isolator-20",
  VOLUME_24 = "volume-24",
  VOLUME_MUTE_24 = "volume-mute-24",
  WARNING_16 = "warning-16",
  X_24 = "x-24",
  YOUTUBE_24 = "youtube-24",
}

export enum ICON_ALIGN_OPTIONS {
  AFTER = "after",
  BEFORE = "before",
}
